import styled from "@emotion/styled";

export const Inputs = styled.div`
  margin-block-start: 40px;
`;
